import React, { useRef, useState } from "react";
import { Props } from "./types";
import { HStack, Text, VStack, useOutsideClick } from "@chakra-ui/react";
import { Icon } from "semente-js";
import { Calendar } from "react-date-range";
import { formatDate } from "src/common";
import { motion } from "framer-motion";
import { pt } from "date-fns/locale";

const DatePicker: React.FC<Props> = ({
  value,
  onChange,
  placeholder = "Data",
  isInvalid = false,
  errorMessage,
  minDate,
  disabled = false,
  id,
  outputFormat = "yyyy-MM-dd",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dateRef = useRef<any>(null);

  useOutsideClick({
    ref: dateRef,
    handler: () => setIsOpen(false),
  });

  const dateValue = value
    ? typeof value === "string"
      ? new Date(value)
      : value
    : undefined;

  const handleDateChange = (date: Date) => {
    setIsOpen(false);
    if (onChange) {
      // Retorna no formato especificado (padrão: yyyy-MM-dd)
      const formattedDate = formatDate(date, outputFormat);
      onChange(formattedDate);
    }
  };

  const displayValue = dateValue
    ? formatDate(dateValue, "dd/MM/yyyy")
    : placeholder;

  return (
    <VStack position={"relative"} alignItems={"flex-start"} w={"100%"}>
      <HStack
        py={"10px"}
        px={"12px"}
        cursor={disabled ? "not-allowed" : "pointer"}
        borderRadius={"8px"}
        background={disabled ? "Gray.$100" : "Gray.$200"}
        onClick={() => !disabled && setIsOpen(true)}
        opacity={disabled ? 0.6 : 1}
        borderWidth={"1px"}
        borderColor={
          isInvalid
            ? "Red.pure"
            : dateValue
            ? "Tertiary.pure"
            : "Gray.$400"
        }
        w={"100%"}
        minH={"56px"}
      >
        <Icon name={"calendar-solid"} size="14px" />

        <Text
          fontSize={"LSM"}
          fontWeight={500}
          color={dateValue ? "Gray.$800" : "Gray.$600"}
          flex={1}
        >
          {displayValue}
        </Text>

        <Icon name={"angle-down"} size="14px" />
      </HStack>

      {isOpen && !disabled && (
        <motion.div
          style={{
            position: "absolute",
            borderRadius: "14px",
            background: "#fdfdfd",
            height: "330px",
            width: "360px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            top: "64px",
            left: 0,
            zIndex: 10,
            boxShadow:
              "rgb(0 0 0 / 20%) 0px 3px 3px -2px, rgb(0 0 0 / 14%) 0px 3px 4px 0px, rgb(0 0 0 / 12%) 0px 1px 8px 0px",
          }}
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          ref={dateRef}
        >
          <Calendar
            onChange={handleDateChange}
            locale={pt}
            date={dateValue || new Date()}
            minDate={minDate}
          />
        </motion.div>
      )}

      {errorMessage && (
        <Text
          m={"4px 0 0 0 !important"}
          fontSize={"L_md"}
          color={"Red.pure"}
          fontWeight={400}
        >
          {errorMessage}
        </Text>
      )}
    </VStack>
  );
};

export default DatePicker;

